export function getVenueOrderingUrl(venueId: string): string {
	return `${process.env.REACT_APP_ORDER_URL}venue/${venueId}`;
}
